import { Box, Typography, Switch as MUISwitch } from '@mui/material';

import { ISwitch } from 'constants/types';
import { MedicationFormData } from '../../pages/medications/addMedication/types';

const Switch: React.FC<ISwitch> = ({ component, values, handleSwitch }) => {
  const isChecked = values[component.name as keyof MedicationFormData];

  return (
    <Box
      key={component.id}
      sx={{ gap: 2, pt: 1.5 }}
      className="d-flex align-items-center"
    >
      <Typography>{component.label}</Typography>
      <MUISwitch
        sx={{ ml: 'auto' }}
        color="tertiary"
        name={component.name}
        checked={isChecked}
        onChange={handleSwitch}
        inputProps={{ 'aria-label': component.label || 'Switch' }}
      />
    </Box>
  );
};

export default Switch;
